export default "__VITE_ASSET__D1sXoHIi__"